/**
 * @description 获取配置项
 * @date 2021-03-11
 */
export const config = window.CODEMAOCONFIG;
